export class AppConfig {
    public environment: string = "";
    public tenantId : string= "";
    public clientId: string = "";
    public baseUrl: string = "";
    public apiUrl: string = "";
    public wssUrl: string = "";
    public wellsApiKey: string = "";
    public object_id: string = "";
    public dashboardId: string="";
}